import React, { useEffect, useState } from 'react';
import { ArrowRight } from 'lucide-react';
export function DoubtSection() {
  const [showSticky, setShowSticky] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      // Show sticky button after scrolling past hero (approx 500px)
      if (window.scrollY > 500) {
        setShowSticky(true);
      } else {
        setShowSticky(false);
      }
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const scrollToProduct = () => {
    document.getElementById('producto')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return;
}